// @flow

import { ADD_IMPRESSION_POSITION } from '../constants';
import { getPathname } from '../../router';

export const addImpressionPosition = (id: string) => (dispatch: Function, getState: Function) => {
  const pathName = getPathname(getState());
  dispatch({
    type: ADD_IMPRESSION_POSITION,
    id,
    pathName,
  });
};
export default null;
